import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-flex-initial tw-flex tw-flex-col"
}
const _hoisted_2 = { class: "content tw-flex tw-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "tw-flex tw-items-center tw-mr-2"
}
const _hoisted_4 = { class: "md:tw-text-lg tw-font-bold tw-text-slate-700" }
const _hoisted_5 = {
  key: 0,
  class: "tw-text-sm tw-text-slate-600 md:tw-pb-2"
}
const _hoisted_6 = { class: "header" }
const _hoisted_7 = {
  key: 0,
  class: "tw-block tw-w-full tw-pl-2 tw-border tw-border-1 tw-border-solid tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-b-1 tw-border-slate-200"
}
const _hoisted_8 = { class: "tw-p-0 header" }

import { ArrowLeftIcon } from "lucide-vue-next"
import { computed, PropType } from "vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DialogContainer',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'md'
    },
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    maximized: {
      type: Boolean,
      default: false
    },
    close: {
      type: Boolean,
      default: false
    },
    showBack:{
      type: Boolean,
      default: false
    },
    fullHeight: {
      type: Boolean,
      default: false
    },
    side:{
      type: String as PropType<'top' | 'bottom' | 'left' | 'right' | 'standard'>,
      default: "standard"
    },
    width:{
      type: Number,
      default: 448
    },
    hideSeparator:{
      type: Boolean,
      default: false
    },
    persistent:{
      type: Boolean,
      default: false
    },
    bodyClass:{
      type: String,
      default: null
    },
    footerClass:{
      type: String,
      default: 'tw-px-6 tw-pb-6'
    },
    headerClass: {
      type: String,
      default: 'tw-px-6 tw-pt-2'
    },
    maxWidth: {
      type: String,
      default: '100vw'
    }
  },
  emits: [
    'update:modelValue',
    'back'
  ],
  setup(__props, { emit: __emit }) {

  const props = __props

  const value = computed<boolean>({
    get() {
      if (props.modelValue) {
        return props.modelValue
      }
      else {
        return false
      }
    },
    set(value: boolean) {
      emit('update:modelValue', value)
    }
  })

  const emit = __emit

  const backClicked = () => {
    emit('back')
  }

  const style = computed(() => {
    switch (props.size) {
      case 'sm':

        break;
      case 'md':
        return {
          'width': props.width ? props.width + 'px' : '794px',
          'max-width': '100%',
          'max-height': props.maximized || props.fullHeight ? 'unset' : '95vh'
        }
        break;
    }
  })


return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: value.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event)),
    maximized: __props.maximized || __props.fullHeight,
    position: __props.side??undefined,
    "full-height": __props.fullHeight,
    persistent: __props.persistent,
    class: _normalizeClass(__props.fullHeight ? 'tw-h-full tw-p-0':''),
    style: _normalizeStyle({ 'max-width': __props.maxWidth })
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["flex items-center tw-shadow-2xl tw-max-h-full", (__props.fullHeight === true ? 'full-height' : '')]),
        style: _normalizeStyle({ 'max-width': __props.maxWidth })
      }, [
        _createElementVNode("div", {
          style: _normalizeStyle(style.value),
          class: _normalizeClass(["box-column bg-white full-height overflow-auto", (__props.side === 'left' || __props.side === 'right') ? 'tw-rounded-none' : 'tw-rounded-lg'])
        }, [
          (__props.title || __props.close)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                  class: _normalizeClass(["box-row flex items-center tw-w-full", ((__props.title || __props.close) && !__props.hideSeparator ? 'tw-pb-2' : '') + ' ' + __props.headerClass])
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    (__props.showBack)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createVNode(_unref(ArrowLeftIcon), {
                            size: 24,
                            class: "tw-text-slate-600 tw-cursor-pointer",
                            onClick: backClicked
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.title), 1),
                      (__props.subtitle)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.subtitle), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    (__props.close)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          round: "",
                          flat: "",
                          dense: "",
                          icon: "close",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (value.value = false))
                        }))
                      : _createCommentVNode("", true)
                  ])
                ], 2),
                ((__props.title || __props.close) && !__props.hideSeparator)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["content overflow-auto tw-h-full", (__props.bodyClass ?? 'tw-px-6')])
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["footer", __props.footerClass])
          }, [
            _createElementVNode("div", _hoisted_8, [
              _renderSlot(_ctx.$slots, "buttons")
            ])
          ], 2)
        ], 6)
      ], 6)
    ]),
    _: 3
  }, 8, ["modelValue", "maximized", "position", "full-height", "persistent", "class", "style"]))
}
}

})